import { ComponentProps } from 'react';
import { css } from '@emotion/react';
import { Page } from '@frontend/components';
import { breakpoints } from '@frontend/responsiveness';

type Props = ComponentProps<typeof Page> & {
  error?: string;
};

export const BulkMessagePage = ({ children, ...rest }: Props) => (
  <Page
    {...rest}
    css={css`
      .page-header {
        @media (max-width: ${breakpoints.xsmall.max}px) {
          display: none;
        }
      }
    `}
  >
    {children}
  </Page>
);
